import { render } from "./PropertyEditor.vue?vue&type=template&id=02706328&scoped=true&ts=true"
import script from "./PropertyEditor.vue?vue&type=script&lang=ts"
export * from "./PropertyEditor.vue?vue&type=script&lang=ts"

import "./PropertyEditor.vue?vue&type=style&index=0&id=02706328&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-02706328"]])

export default __exports__